import { Filter } from "app/shared/models/filter";

export class UpdateShipmentsFilter {
  public static readonly type = "[Shipments] updatefilter";
  public constructor(public filter: Filter, public resetPage = false) {}
}
